<template>
  <div id="medkon-tab">
    <!-- filter tier -->
    <div class="px-2">
      <div class="card card-default d-flex shade mb-3">
        <div class="card-body">
          <div class="ml-auto w-25">
            <div class="perpage-el">
              <div class="form-group input-group input-group-right transparent m-b-0 m-t-0" id="post-tier-filter">
                <select name="sort" v-model="filter_tier" @change="tierChange" class="form-control form-custom">
                  <option value="0">Semua Tingkat</option>
                  <option value="1">Tingkat 1</option>
                  <option value="2">Tingkat 2</option>
                  <option value="3">Tingkat 3</option>
                  <option value="4">Tingkat 4</option>
                </select>
                <div class="input-group-append">
                  <span class="input-group-text transparent">
                    <i class="bi bi-stack" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <medkon-tren-media-konvensional-component :key="data_media_konvensional_key" :data="data_media_konvensional"
      :databar="data_media_konvensionalBar" />

    <medkon-tren-group-topik-component v-if="added_charts.includes(9) && data_grup" :key="data_grup_key"
      :data="data_grup" />

    <medkon-tier-source-component v-if="added_charts.includes(15) && data_trend_tier" :data="data_trend_tier" />

    <topik-by-source-component v-if="added_charts.includes(9) && data_topic_source && data_grup"
      :key="data_topic_source_key" :data="data_topic_source" :tipe="'medkon'" />

    <persentase-tren-sentiment-component v-if="data_sentiment && data_sentiment_stats && added_charts.includes(5)"
      :key="data_sentiment_key" :data="data_sentiment" :stats="data_sentiment_stats" />

    <tren-by-topik-component v-if="data_mention_per_topik &&
      data_mention_per_topik_stats &&
      added_charts.includes(6)
      " :key="data_mention_per_topik_key" :data="data_mention_per_topik" :stats="data_mention_per_topik_stats" />

    <!-- <medkon-stasiun-tv-component v-if="added_charts.includes(7) && data_stasiun_tv" :key="data_stasiun_tv_key"
      :data="data_stasiun_tv" />

    <medkon-program-stasiun-tv-component v-if="added_charts.includes(7) && data_program_stasiun_tv"
      :key="data_program_stasiun_tv_key" :data="data_program_stasiun_tv" />

    <medkon-jurnalis-media-cetak-component v-if="added_charts.includes(8) && data_jurnalis_media_cetak"
      :key="data_jurnalis_media_cetak_key" :data="data_jurnalis_media_cetak" /> -->

    <!-- <persentase-tren-emotion-component v-if="added_charts.includes(11) && data_emotion" :key="data_emotion_key"
      :data="data_emotion" :stats="data_emotion_stats" /> -->

    <medkon-word-cloud-component v-if="!is_loading" ref="word_cloud" :tier="filter_tier" />
    <!-- add chart button -->
    <div class="overlay-button">
      <button title="Manage Grafik" class="btn btn-warning" @click="addChart">
        <i class="pg-icon">chart_add</i>
      </button>
    </div>
    <!-- modal dynamic component -->
    <modal-dynamic-component v-if="modal" :key="modal_key" :modal="modal" :data="added_charts" />
    <!-- tour component -->
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import medkon_tier_source from "@/views/components/analytics/general/medkon_tier_source.vue";
// import medkon_stasiun_tv from "@/views/components/analytics/general/medkon_stasiun_tv.vue";
// import medkon_program_stasiun_tv from "@/views/components/analytics/general/medkon_program_stasiun_tv.vue";
// import medkon_jurnalis_media_cetak from "@/views/components/analytics/general/medkon_jurnalis_media_cetak.vue";
import medkon_tren_media_konvensional from "@/views/components/analytics/general/medkon_tren_media_konvensional.vue";
import persentase_tren_sentiment from "@/views/components/analytics/general/persentase_tren_sentiment.vue";
import tren_by_topik from "@/views/components/analytics/general/tren_by_topik.vue";
import medkon_tren_group_topik from "@/views/components/analytics/general/medkon_tren_group_topik.vue";
import topik_by_source from "@/views/components/analytics/general/topik_by_source.vue";
// import persentase_tren_emotion from "@/views/components/analytics/general/persentase_tren_emotion.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import medkon_word_cloud from "@/views/components/analytics/general/medkon_word_cloud.vue";
import modal_add_medkon_chart from "@/views/components/analytics/general/modal_add_medkon_chart.vue";

export default {
  name: "tab_medkon",
  components: {
    // "medkon-stasiun-tv-component": medkon_stasiun_tv,
    // "medkon-program-stasiun-tv-component": medkon_program_stasiun_tv,
    // "medkon-jurnalis-media-cetak-component": medkon_jurnalis_media_cetak,
    "medkon-tren-media-konvensional-component": medkon_tren_media_konvensional,
    "persentase-tren-sentiment-component": persentase_tren_sentiment,
    "tren-by-topik-component": tren_by_topik,
    "medkon-tren-group-topik-component": medkon_tren_group_topik,
    "topik-by-source-component": topik_by_source,
    // "persentase-tren-emotion-component": persentase_tren_emotion,
    "modal-dynamic-component": modal_dynamic,
    "medkon-tier-source-component": medkon_tier_source,
    "medkon-word-cloud-component": medkon_word_cloud,
  },
  data() {
    return {
      tour_steps: [],
      filter_tier: "0",

      data_stasiun_tv_key: 0,
      data_stasiun_tv: null,

      data_program_stasiun_tv_key: 10,
      data_program_stasiun_tv: null,

      data_jurnalis_media_cetak_key: 20,
      data_jurnalis_media_cetak: null,

      data_media_konvensional_key: 30,
      data_media_konvensional: null,
      data_media_konvensionalBar: null,

      data_sentiment_key: 40,
      data_sentiment: null,
      data_sentiment_stats: null,

      data_mention_per_topik_key: 50,
      data_mention_per_topik: null,
      data_mention_per_topik_stats: null,

      data_grup_key: 60,
      data_grup: null,

      modal_key: 70,
      modal: null,
      added_charts: this.$store.getters.user.project.project_detail.charts,

      data_emotion_key: 80,
      data_emotion: null,
      data_emotion_stats: null,

      data_topic_source_key: 90,
      data_topic_source: null,

      data_trend_tier: null,

      allData: {},
      is_loading: true,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    getData: function () {
      this.is_loading = true;
      var params = this.$route.query;
      params.tier = this.filter_tier;
      if ("items" in params) {
        delete params.items;
      }
      if ("tipe" in params) {
        delete params.tipe;
      }
      if (this.filter_tier == "0") {
        delete params.tier;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (query != "") {
        this.data_stasiun_tv = null;
        this.data_program_stasiun_tv = null;
        this.data_jurnalis_media_cetak = null;
        this.data_media_konvensional = null;
        this.data_media_konvensionalBar = null;
        this.data_grup = null;
        this.data_sentiment = null;
        this.data_mention_per_topik = null;
        this.data_emotion = null;
        this.data_emotion_stats++;
        this.data_trend_tier = null;

        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "analytics-formed/" +
          this.id_project +
          "?" +
          query;

        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.data_media_konvensional = {};
              this.data_media_konvensionalBar = {};
              this.allData = response.data;
              if (response.data.trend_tier) {
                this.data_trend_tier = response.data.trend_tier;

                this.data_trend_tier.news.series.forEach((series, key) => {
                  key++;

                  if (series[0] == 'Tier ' + key) {
                    series[0] = 'Tingkat ' + key;
                  }
                });
              } else {
                this.data_trend_tier = {
                  media_cetak: {
                    series: [
                      ["Tingkat 1", 0],
                      ["Tingkat 2", 0],
                      ["Tingkat 3", 0],
                      ["Tingkat 4", 0],
                    ],
                  },
                  media_tv: {
                    series: [
                      ["Tingkat 1", 0],
                      ["Tingkat 2", 0],
                      ["Tingkat 3", 0],
                      ["Tingkat 4", 0],
                    ],
                  },
                  news: {
                    series: [
                      ["Tingkat 1", 0],
                      ["Tingkat 2", 0],
                      ["Tingkat 3", 0],
                      ["Tingkat 4", 0],
                    ],
                  },
                };
              }

              // this.data_trend_tier.source = 'news'

              if ("table_channel_tv" in response.data) {
                this.data_stasiun_tv = {};
                this.assembleTVTabel(response.data.table_channel_tv);
              }

              if ("trend_channel_tv" in response.data) {
                this.data_program_stasiun_tv = {};
                this.assembleTrenTv(response.data.trend_channel_tv);
              }

              if ("bar_program" in response.data) {
                this.assembleTVProgram(response.data.bar_program);
              }

              if ("table_jurnalis" in response.data) {
                this.data_jurnalis_media_cetak = {};
                this.assembleJurnalis(response.data.table_jurnalis);
              }

              if ("bar_koran" in response.data) {
                this.assembleMediaCetak(response.data.bar_media_cetak);
              }

              this.assembleTrenMediaCetak(
                response.data.trend_formed,
                response.data.stats
              );
              this.data_sentiment_stats = [
                {
                  name: "Positif",
                  y: response.data.stats.positif,
                  color: $("body").css("--success") + "AA",
                  source: 'news'
                },
                {
                  name: "Netral",
                  y: response.data.stats.netral,
                  color: "#0e6d87AA",
                  source: 'news'
                },
                {
                  name: "Negatif",
                  y: response.data.stats.negatif,
                  color: $("body").css("--danger") + "AA",
                  source: 'news'
                },
              ];
              this.data_sentiment_stats["name"] = "Berita";

              if ("trend_sentiment_formed" in response.data) {
                this.assembleDataSentiment(
                  response.data.trend_sentiment_formed
                );
              }

              if ("bar_topik_formed" in response.data) {
                this.data_mention_per_topik_stats =
                  response.data.bar_topik_formed;
                this.data_mention_per_topik++;
              }

              if ("trend_topik_formed" in response.data) {
                this.assembleDataMentionPerTopik(
                  response.data.trend_topik_formed
                );
              }

              if ("trend_group_formed" in response.data) {
                if (!Array.isArray(response.data.trend_group_formed)) {
                  this.data_grup = response.data.trend_group_formed;
                  // this.data_grup.source = 'news'
                } else {
                  this.data_grup = {};
                }
              }

              if ("trend_emo" in response.data) {
                this.data_emotion_stats = [
                  {
                    name: "Netral",
                    y: response.data.stats.no_emotion,
                    source: 'news'
                  },
                  {
                    name: "Senang",
                    y: response.data.stats.joy,
                    color: $("body").css("--success") + "AA",
                    source: 'news'
                  },
                  {
                    name: "Takut",
                    y: response.data.stats.fear,
                    color: $("body").css("--warning") + "AA",
                    source: 'news'
                  },
                  {
                    name: "Sedih",
                    y: response.data.stats.sad,
                    color: $("body").css("--teal") + "AA",
                    source: 'news'
                  },
                  {
                    name: "Marah",
                    y: response.data.stats.anger,
                    color: $("body").css("--danger") + "AA",
                    source: 'news'
                  },
                ];
                this.data_emotion_stats["name"] = "Berita";
                this.assembleDataEmotion(response.data.trend_emo);
              }
            } else {
              this.data_stasiun_tv = {
                table: {},
                grafik: {},
              };
              this.data_program_stasiun_tv = {};
              this.data_jurnalis_media_cetak = {
                table: {},
                grafik: {},
              };
              this.data_media_konvensional = {
                grafik: {},
                stats: {},
              };
              this.data_media_konvensionalBar = {
                categories: {},
                series: {},
              };
            }
          })
          .catch((err) => {
            this.data_stasiun_tv = {
              table: {},
              grafik: {},
            };
            this.data_jurnalis_media_cetak = {
              table: {},
              grafik: {},
            };
            console.log(err);
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
    getTopikSource: function () {
      var params = this.$route.query;
      if ("items" in params) {
        delete params.items;
      }
      if ("tipe" in params) {
        delete params.tipe;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        this.data_topic_source = null;
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "charts/bar/topic-source/" +
          this.id_project +
          "?tipe=medkon&" +
          query;
        this.$http.get(api).then((response) => {
          if (response.status == 200) {
            this.data_topic_source = response.data;
            this.data_topic_source.source = 'news';
          } else {
            this.data_topic_source = {};
          }
        });
      }
    },
    assembleTVTabel: function (dataset) {
      let tabel_body = [];
      if (dataset) {
        for (let index in dataset) {
          let row = [];
          row[0] = dataset[index]._id;
          row[1] = dataset[index].total;
          tabel_body.push(row);
        }
        this.data_stasiun_tv.table = {};
        this.data_stasiun_tv.table.dt_head = ["Stasiun TV", "Jumlah"];
        this.data_stasiun_tv.table.dt_body = tabel_body;
        this.data_stasiun_tv.table.dt_config = {
          language: {
            thousands: ".",
            search: "Cari TV:",
            zeroRecords: "Data tidak tersedia",
            info: "Menampilkan halaman _PAGE_ dari _PAGES_",
            infoEmpty: "Menampilkan 0 data",
            lengthMenu: "Tampilkan _MENU_ data",
          },
          pageLength: 5,
          lengthMenu: [5, 10, 25, 50, 75, 100],
          aaSorting: [[1, "desc"]],
        };
        this.data_stasiun_tv_key++;
      }
    },
    assembleTrenTv: function (dataset) {
      let y = [];
      for (let index in dataset.label) {
        if (dataset.label[index] != "date") {
          let row = {
            name: dataset.label[index],
            data: dataset[dataset.label[index]],
          };
          y.push(row);
        }
      }
      this.data_stasiun_tv.grafik = {
        y: y,
        x: dataset.date,
      };
      this.data_stasiun_tv_key++;
    },
    assembleTVProgram: function (dataset) {
      let series = [];
      for (let index in dataset) {
        series.push([dataset[index]._id, dataset[index].count]);
      }
      this.data_program_stasiun_tv.series = series;
      this.data_program_stasiun_tv.yLabel = "Frekuensi";
      this.data_program_stasiun_tv_key++;
    },
    assembleJurnalis: function (dataset) {
      let tabel_body = [];
      for (let index in dataset) {
        let row = [];
        row[0] = dataset[index]._id;
        row[1] = dataset[index].count;
        tabel_body.push(row);
      }
      this.data_jurnalis_media_cetak.table = {};
      this.data_jurnalis_media_cetak.table.dt_head = ["Jurnalis", "Jumlah"];
      this.data_jurnalis_media_cetak.table.dt_body = tabel_body;
      this.data_jurnalis_media_cetak.table.dt_config = {
        language: {
          thousands: ".",
          search: "Cari Jurnalis:",
          zeroRecords: "Data tidak tersedia",
          info: "Menampilkan halaman _PAGE_ dari _PAGES_",
          infoEmpty: "Menampilkan 0 data",
          lengthMenu: "Tampilkan _MENU_ data",
        },
        pageLength: 5,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        aaSorting: [[1, "desc"]],
      };
    },
    assembleMediaCetak: function (dataset) {
      let series = [];
      let sentimentPositif = [];
      let sentimentNetral = [];
      let sentimentNegatif = [];
      let categories = [];
      for (let index in dataset) {
        categories.push(dataset[index]._id.account);
        sentimentPositif.push(dataset[index].positif);
        sentimentNetral.push(dataset[index].netral);
        sentimentNegatif.push(dataset[index].negatif);
      }
      series = [
        {
          name: "Positif",
          color: "#28a745",
          data: sentimentPositif,
        },
        {
          name: "Netral",
          color: "#17a2b8",
          data: sentimentNetral,
        },
        {
          name: "Negatif",
          color: "#dc3545",
          data: sentimentNegatif,
        },
      ];

      this.data_jurnalis_media_cetak.grafik = {
        series: series,
        categories: categories,
        yLabel: "Frekuensi",
      };

      this.data_jurnalis_media_cetak_key++;
    },
    assembleTrenMediaCetak: function (dataset, stats) {
      let y = [
        {
          color: "#28a745",
          name: "Media Online",
          data: dataset.news,
        },
        // {
        //   color: "#6c757d",
        //   name: "Media Cetak",
        //   data: dataset.media_cetak,
        // },
        // {
        //   color: "#e83e8c",
        //   name: "Media TV",
        //   data: dataset.media_tv,
        // },
      ];

      let stat = {
        total: stats.total.toString(),
        media_tv: stats.media_tv.toString(),
        media_cetak: stats.media_cetak.toString(),
        news: stats.news.toString(),
      };

      this.data_media_konvensional.grafik = {
        y: y,
        x: dataset.date,
        source: 'news'
      };

      this.data_media_konvensionalBar = {
        categories: dataset.date,
        series: y,
      };
      this.data_media_konvensional.stats = stat;
      this.data_media_konvensional_key++;
    },
    assembleDataSentiment: function (dataset) {
      let data = {
        source: 'news',
        x: dataset.date,
        y: [
          {
            name: "Positif",
            data: dataset.positif,
            color: $("body").css("--success"),
          },
          {
            name: "Netral",
            data: dataset.netral,
            color: $("body").css("--info"),
            // visible: false,
          },
          {
            name: "Negatif",
            data: dataset.negatif,
            color: $("body").css("--danger"),
          },
        ],
        yName: "Total",
      };
      this.data_sentiment = data;
      this.data_sentiment_key++;
    },
    assembleDataMentionPerTopik: function (dataset) {
      let chart_data = [];
      for (let row in dataset) {
        if (row != "date") {
          chart_data.push({
            name: row,
            data: dataset[row],
          });
        }
      }
      let data = {
        x: dataset.date,
        y: chart_data,
        yName: "Total",
      };

      this.data_mention_per_topik = data;
      this.data_mention_per_topik.source = 'news';
      this.data_mention_per_topik_key++;
    },
    assembleDataEmotion: function (dataset) {
      let data = {
        x: dataset.date,
        y: [
          {
            name: "Netral",
            data: dataset.no_emotion
          },
          {
            name: "Senang",
            data: dataset.joy,
            color: $("body").css("--success") + "AA"
          },
          {
            name: "Takut",
            data: dataset.fear,
            color: $("body").css("--warning") + "AA"
          },
          {
            name: "Sedih",
            data: dataset.sad,
            color: $("body").css("--teal") + "AA"
          },
          {
            name: "Marah",
            data: dataset.anger,
            color: $("body").css("--danger") + "AA"
          },
        ],
        yName: "Total",
      };
      this.data_emotion = data;
      this.data_emotion.source = 'news';
      this.data_emotion_key++;
    },
    addChart: function () {
      if (!this.modal) {
        this.modal = {
          title: "Manage Grafik",
          subtitle:
            "Silahkan pilih grafik yang akan ditambahkan ke halaman analytics.",
          component: modal_add_medkon_chart,
        };
      } else {
        this.modal_key++;
      }
    },
    tierChange: function () {
      this.getData();
      this.getTopikSource();
      this.$refs.word_cloud.tierChange(this.filter_tier);
    },
  },
  mounted: function () {
    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: ".card-body",
      header: {
        title: "Berpindah Tab",
      },
      content:
        "Anda dapat berpindah tab dengan melakukan klik pada media online atau media sosial.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#grafik-tren",
      header: {
        title: "Tren Media Online",
      },
      content:
        "Menampilkan Grafik Tren dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#tren-group",
      header: {
        title: "Tren Group Topik",
      },
      content:
        "Menampilkan Grafik Tren Group Topik dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#topik-by-source",
      header: {
        title: "Tren Topik Berdasarkan Source",
      },
      content:
        "Menampilkan grafik tren topik berdasarkan sumber dari media online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#grafik-sentimen",
      header: {
        title: "Tren Sentimen",
      },
      content:
        "Menampilkan Grafik dan Persentase Sentimen dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#daftar-topik",
      header: {
        title: "Daftar Topik",
      },
      content:
        "Menampilkan daftar topik dengan jumlah per sentimen dan total data dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#tren-topik",
      header: {
        title: "Tren Topik",
      },
      content:
        "Menampilkan Grafik data tren berdasarkan topik dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#stasiun-tv",
      header: {
        title: "Stasiun TV",
      },
      content:
        "Menampilkan daftar tren stasiun TV dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#grafik-stasiun",
      header: {
        title: "Data Tren Stasiun TV",
      },
      content:
        "Menampilkan grafik tren stasiun TV dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[12] = {
      target: "#program-stasiun",
      header: {
        title: "Program Stasiun TV",
      },
      content:
        "Menampilkan grafik jumlah mention untuk setiap program stasiun TV dari Media Online dalam range waktu sesuai dengan filter tanggal..",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[13] = {
      target: "#jurnalis",
      header: {
        title: "Jurnalis",
      },
      content:
        "Menampilkan daftar jurnalis dengan jumlah postingannya dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[14] = {
      target: "#media-cetak",
      header: {
        title: "Media Cetak",
      },
      content:
        "Menampilkan grafik media cetak dengan jumlah per sentimen dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[15] = {
      target: "#emotion",
      header: {
        title: "Emotion",
      },
      content:
        "Menampilkan persentase dan grafik tren emotion dari Media Online dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
  watch: {
    $route() {
      this.getData();
      this.getTopikSource();
    },
  },
  created: function () {
    this.getData();
    this.getTopikSource();
  },
};
</script>
